import React from 'react';
import { Alert, Button } from '@mui/material';
import { BUSINESS_QUOTAS } from './BusinessFormConstants';

const UpgradePrompt = ({
  userAccountType,
  currentBusinessCount,
  businessQuota,
  onUpgrade
}) => (
  <Alert
    severity="warning"
    sx={{ mb: 3, borderRadius: 2 }}
    action={
      userAccountType === 'free' && (
        <Button
          color="inherit"
          size="small"
          variant="outlined"
          onClick={onUpgrade}
          sx={{ whiteSpace: 'nowrap' }}
        >
          Upgrade
        </Button>
      )
    }
  >
    {userAccountType === 'free'
      ? `You have reached your free plan limit of ${businessQuota} business. Upgrade to Premium for up to ${BUSINESS_QUOTAS.premium} businesses.`
      : `You have reached the Premium limit of ${businessQuota} businesses. Contact support if you need more.`
    }
  </Alert>
);

export default UpgradePrompt;